import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import HomeLayout from "@/components/home/home-layout";
import LottieLoading from "@/components/lottie/lottie-loading";
import { isIOSMobileBrowser } from "@/utils/device";

const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || "";
const PLAY_STORE_URL = process.env.REACT_APP_PLAY_STORE_URL || "";

const Invite: React.FC = () => {
  const [searchParams] = useSearchParams();
  const startedRef = useRef(false);
  const code = searchParams.get("code");

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    redirectToStore();
  }, []);

  const redirectToStore = () => {
    if (isIOSMobileBrowser()) {
      window.location.replace(APP_STORE_URL);
      return;
    }

    const playStoreUrl = code
      ? `${PLAY_STORE_URL}&referrer=${encodeURIComponent(`code=${code}`)}`
      : PLAY_STORE_URL;
    window.location.replace(playStoreUrl);
  };

  return (
    <div className="flex flex-1 p-4 items-center justify-center">
      <LottieLoading />
    </div>
  );
};

const InvitePage: React.FC = () => {
  return <HomeLayout children={<Invite />}></HomeLayout>;
};

export default InvitePage;
